export default {
  data() {
    return {
      txt: " 这是组件主题样式 "
    }
  }
}



// WEBPACK FOOTER //
// ./src/ni-ui/theme/theme.js